export default __webpack_public_path__ + "static/raj-cc82575e4230775a213399bd38c44fe2.png";